var map = {
	"./Boulingrin.png": [
		95352,
		95352
	],
	"./BoulingrinCentralHalls.png": [
		14545,
		14545
	],
	"./Butcher.png": [
		84912,
		84912
	],
	"./Caves.png": [
		50843,
		50843
	],
	"./ChampagneAugustin.png": [
		87553,
		87553
	],
	"./Chocolatier.png": [
		53086,
		53086
	],
	"./Poultry.png": [
		31638,
		31638
	],
	"./Primeur.png": [
		7105,
		7105
	],
	"./ReimsCathedral.png": [
		11165,
		11165
	],
	"./VerzenayLighthouse.png": [
		44677,
		44677
	],
	"./VerzyNationalForest.png": [
		42804,
		42804
	],
	"./WalkJLS.png": [
		99945,
		99945
	],
	"./WarMemories.png": [
		80534,
		80534
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 74803;
module.exports = webpackAsyncContext;